import initialState from "store/initialState";
import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import { CREATE_SUBJECT, UPDATE_SUBJECT } from "actions/subjects";
import { UPDATE_CONFIG } from "actions/config";
import { ADD_RULE } from "actions/rules";
import { SET_SUBMITTING } from "actions/submittingChanges";

const submittingChanges = (state = initialState.submittingChanges, action: any) => {
  switch (action.type) {
    case pending(CREATE_SUBJECT):
    case pending(UPDATE_SUBJECT):
    case pending(UPDATE_CONFIG):
    case pending(ADD_RULE):
      return true;
    case failed(CREATE_SUBJECT):
    case failed(UPDATE_SUBJECT):
    case failed(UPDATE_CONFIG):
    case failed(ADD_RULE):
    case fulfilled(CREATE_SUBJECT):
    case fulfilled(UPDATE_SUBJECT):
    case fulfilled(UPDATE_CONFIG):
    case fulfilled(ADD_RULE):
      return false;

    case SET_SUBMITTING:
      return !!action.payload.isSubmitting;
  }
  return state;
};

export default submittingChanges;
